<template>
    <SwContainer
        v-bind="{
            paddingY,
            bgColor,
            bgImage,
            bgOpacity,
        }"
    >
        <div
            :class="{
                [$style['block']]: true,
                [$style['block_inverted']]: inverted,
                [$style['block_reversed']]: reversed,
            }"
        >
            <div :class="$style['block__body']">
                <h1
                    :class="[$style['block__title'], 'sw-title']"
                    v-html="title"
                />

                <div
                    :class="[$style['block__text'], 'sw-text']"
                    v-html="text"
                />

                <template v-if="noIndex">
                    <client-only>
                        <nofollow>
                            <noindex>
                                <SwButton
                                    v-if="buttonUrl.includes('//')"
                                    :href="buttonUrl"
                                    target="_blank"
                                >
                                    {{ buttonLabel }}
                                </SwButton>

                                <SwButton v-else :to="buttonUrl">
                                    {{ buttonLabel }}
                                </SwButton>
                            </noindex>
                        </nofollow>
                    </client-only>
                </template>

                <template v-else>
                    <SwButton
                        v-if="buttonUrl.includes('//')"
                        :href="buttonUrl"
                        target="_blank"
                    >
                        {{ buttonLabel }}
                    </SwButton>

                    <SwButton v-else :to="buttonUrl">
                        {{ buttonLabel }}
                    </SwButton>
                </template>
            </div>

            <FeedbackForm
                :pivot-id="pivotId"
                :title="formTitle"
                :text="formText"
                :fields="formFields"
                :button-text="formButtonLabel"
                :button-text-after-submit="formButtonAfterSubmit"
                :class="$style['block__form']"
            />
        </div>
    </SwContainer>
</template>

<script>
export default {
  name: 'TextAndForm',

  components: {
    FeedbackForm: () => import('@@/website/components/common/FeedbackForm')
  },

  props: {
    pivotId: {
      type: [Number, String],
      default: null
    },

    title: {
      type: String,
      default: 'Заголовок'
    },

    text: {
      type: String,
      default: 'Используйте текст над изображением, чтобы дать вашим клиентам представление о вашем бренде. Выберите изображение и текст, который относится к вашему стилю и истории.'
    },

    buttonLabel: {
      type: String,
      default: 'Кнопка CTA'
    },

    buttonUrl: {
      type: String,
      default: '/'
    },

    noIndex: {
      type: Boolean,
      default: false
    },

    formTitle: {
      type: String,
      default: 'Заголовок'
    },

    formText: {
      type: String,
      default: ''
    },

    formFields: {
      type: Array,
      default: () => []
    },

    formButtonLabel: {
      type: String,
      default: ''
    },

    formButtonAfterSubmit: {
      type: String,
      default: ''
    },

    paddingY: {
      type: String,
      default: 's'
    },

    bgColor: {
      type: String,
      default: '#FFFFFF'
    },

    bgImage: {
      type: String,
      default: ''
    },

    bgOpacity: {
      type: String,
      default: '0%'
    },

    inverted: {
      type: Boolean,
      default: false
    },

    reversed: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" module>
@import (reference) "@@/assets/Web.less";

.block {
  display: flex;
  align-items: center;
  width: 100%;
  margin: auto 0;

  @media screen and (max-width: @bp-mobile-small) {
    flex-direction: column;
  }

  &__body {
    width: 100%;
    @media screen and (max-width: @bp-mobile-small) {
      margin: 0 0 64px;
    }
  }

  &_reversed &__body {
    @media screen and (max-width: @bp-mobile-small) {
      margin: 64px 0 0;
    }
  }

  &__title {
    font-size: 40px;
    font-weight: 600;
    line-height: 48px;
    margin-top: 0;
    margin-bottom: 24px;
    @media screen and (max-width: @bp-mobile-big) {
      margin-bottom: 32px;
    }
  }

  &__text {
    display: block;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 0;
    margin-bottom: 24px;
    @media screen and (max-width: @bp-mobile-big) {
      margin-bottom: 32px;
    }
  }

  &_inverted &__title,
  &_inverted &__text {
    color: #FFFFFF;
  }

  &__form {
    width: 100%;
    max-width: 426px;
    margin-left: 114px;

    @media screen and (max-width: @bp-mobile-big) {
      margin-left: 75px;
    }

    @media screen and (max-width: @bp-mobile-small) {
      max-width: 100%;
      margin-left: 0;
    }
  }

  &_reversed &__form {
    margin-left: 0;
    margin-right: 114px;
    order: -1;

    @media screen and (max-width: @bp-mobile-big) {
      margin-right: 75px;
    }

    @media screen and (max-width: @bp-mobile-small) {
      margin-right: 0;
    }
  }
}
</style>
